// adapters/index.js
import { adaptMnhInvoice } from "./mnh.adapter";
import { adaptManaswiniInvoice } from "./manaswini.adapter";
import { ORG_CODES } from "../../../shared/constants";
import { adaptVedamaayuInvoice } from "./vedamaayu.adapter";

export const getInvoiceAdapter = (orgCode,dto) => {
  switch (orgCode) {
    case ORG_CODES.MNH:
      return adaptMnhInvoice(dto);
    case ORG_CODES.MANASWINI:
      return adaptManaswiniInvoice(dto);
    case ORG_CODES.VEDAMAAYU:
      return adaptVedamaayuInvoice(dto);
    default:
      return (dto) => dto; // already standard
  }
};
